import axios from "axios";
import useAdminRights from "backend/hooks/misc/useAdminRights";
import useTopElements from "backend/hooks/model/useTopElements";
import { t } from "i18next";
import useMeaQuery from "qpr-base/apihooks/useMeaQuery";
import { THierarchyMode } from "qpr-base/configuration/types";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import { RawData } from "./index.dto";

const configQuery = async (
  elementType: string,
  modelId: string,
  history: any
) => {
  const deleteData = await axios
    .post("/workflow/validateconfig", {
      modelId,
      type: "delete",
      elementType: elementType,
    })
    .catch((err) => {
      if (err.response.status === 401) {
        alert(t("Unauthorized request!"));
        history.goBack();
      }
      return Promise.reject(err);
    });
  const editData = await axios
    .post("/workflow/validateconfig", {
      modelId,
      type: "modify",
      elementType: elementType,
    })
    .catch((err) => {
      if (err.response.status === 401) {
        alert(t("Unauthorized request!"));
        history.goBack();
      }
      return Promise.reject(err);
    });
  const createData = await axios
    .post("/workflow/validateconfig", {
      modelId,

      type: "create",
      elementType: elementType,
    })
    .catch((err) => {
      if (err.response.status === 401) {
        alert(t("Unauthorized request!"));
        history.goBack();
      }
      return Promise.reject(err);
    });
  return {
    data: {
      create: createData?.data?.configFound,
      edit: editData?.data?.configFound,
      delete: deleteData?.data?.configFound,
    },
  };
};

const useKpisAndProjectsQueries = (hierarchyMode: THierarchyMode) => {
  const ctx = useAppContext();
  const [userRole, setUserRole] = useState("");

  const topScorecardSymbol = "L0";

  let hierarchyQuery;
  if (hierarchyMode === "Perspectives")
    hierarchyQuery = `[${ctx.fullModelId}].scorecard(criteria="symbol=\\"${topScorecardSymbol}\\"").topelement.childobjects(recursive=true,criteria="typename=\\"Perspective\\" OR typename=\\"Strategic Objective\\"")`;
  else
    hierarchyQuery = `[${ctx.fullModelId}].scorecard(criteria="symbol=\\"${topScorecardSymbol}\\"").childobjects(recursive=true)`;

  const { data: hierarchyData, isLoading: isHierarchyDataLoading } =
    useMeaQuery<Array<RawData>>(
      `${hierarchyQuery}`,
      `id,name,symbol,typename,level,topelementid,value(series="JS_ATTR",period="firstforseries",as="translations"),related(relation=parentObjects,as="parentid")`,
      `${false ? "typename,name,symbol" : "level,name,symbol"}`
    );

  const { data: topElements, isLoading: topElementsLoading } = useTopElements();

  const history = useHistory();

  const isAdmin = useAdminRights();

  const { data: kpisConfigsData, isLoading: kpisConfigsLoading } = useQuery(
    "kpisQuery",
    () => {
      return configQuery("KPI", ctx.fullModelId, history);
    },
    {
      enabled: true,
      staleTime: 0,
      cacheTime: 0,
    }
  );
  const { data: projectsConfigsData, isLoading: projectsConfigsLoading } =
    useQuery(
      "projectsQuery",
      () => {
        return configQuery("Initiative", ctx.fullModelId, history);
      },
      {
        enabled: true,
        staleTime: 0,
        cacheTime: 0,
      }
    );
  useEffect(() => {
    const fetchRole = async () => {
      const data = await axios.get("/workflow/role");
      setUserRole(data?.data?.data?.role || "");
    };
    fetchRole();
  }, []);
  return {
    hierarchyData,
    topElements,
    topElementsLoading,
    isHierarchyDataLoading,
    isAdmin,
    kpisConfigsData,
    kpisConfigsLoading,
    projectsConfigsData,
    projectsConfigsLoading,
    userRole,
  };
};

export default useKpisAndProjectsQueries;
